const BLOG = 'blog';
const CASO_EXITO = 'caso_exito';

module.exports = {
  BLOG,
  CASO_EXITO,
};
